/* eslint-disable no-undef */

import api from '../api'
import Vue from 'vue'

export const GET_RECORDS = 'GET_RECORDS'
const finished = 'finished'
const unfinished = 'unfinished'
export default {
  state: {finishedOrders: [], unfinishedOrders: []},
  mutations: {
    [GET_RECORDS] (state, data) {
      if (data.param === undefined) {
        return
      }
      if (data.param.type === finished) {
        if (data.param.page === 1) {
          Vue.set(state, 'finishedOrders', data.data.orders)
        } else {
          let oldOrders = JSON.parse(JSON.stringify(state.finishedOrders))
          Array.prototype.push.apply(oldOrders, data.data.orders)
          Vue.set(state, 'finishedOrders', oldOrders)
        }
      } else if (data.param.type === unfinished) {
        if (data.param.page === 1) {
          Vue.set(state, 'unfinishedOrders', data.data.orders)
        } else {
          let oldOrders = JSON.parse(JSON.stringify(state.unfinishedOrders))
          Array.prototype.push.apply(oldOrders, data.data.orders)
          Vue.set(state, 'unfinishedOrders', oldOrders)
        }
      }
    }
  },
  actions: {
    [GET_RECORDS] ({commit}, param) {
      return new Promise(function (resolve, reject) {
        api.getRecords(param.user, param.param.type, param.param.page).then((data) => {
          commit(GET_RECORDS, {data: data, param: param.param})
          resolve()
        }, (data) => {
          commit(GET_RECORDS, {finishedOrders: [], unfinishedOrders: []})
          reject(data)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/records.js